import { Rule } from 'rc-field-form/lib/interface';

// Custom phone regex that allows optional "+" at the start
const PHONE_WITH_PLUS_REGEX = /^\+?\d+$/;

// Custom phone rules that allow "+" at the start
export const customPhoneRules: Rule[] = [
  {
    pattern: PHONE_WITH_PLUS_REGEX,
    message: 'Must be numbers only, optionally starting with +.',
  },
  {
    max: 16,
    message: 'Maximum 16 characters (including +).',
  },
];
